/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_TimingInputs */



/**
* | output |
* | --- |
* | "Timing Issue" |
*
* @param {Manual_Qc_Type_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_timing = /** @type {((inputs?: Manual_Qc_Type_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Probleme de timing")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing-Problem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema di tempistica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проблема со временем")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时序问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングの問題")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय संबंधी समस्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Problema de sincronização")
	return /** @type {LocalizedString} */ ("Timing Issue")
});